const ROUTINE_TEXT_MIN = 8;

class RoutineSection extends HTMLElement {
  connectedCallback() {
    this.heading = this.querySelector(".routine__heading");
    this.steps = Array.from(this.querySelectorAll("[data-step]"));
    this._fitRaf = null;
    this._abort = new AbortController();

    this.scheduleFit();

    const { signal } = this._abort;
    window.addEventListener("resize", () => this.scheduleFit(), { signal });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.scheduleFit());
    }
  }

  disconnectedCallback() {
    this._abort.abort();
  }

  isMobile() {
    return window.matchMedia("(min-width: 990px)").matches === false;
  }

  readCssPx(varName, fallback) {
    const raw = getComputedStyle(this).getPropertyValue(varName).trim();
    const value = parseFloat(raw);
    return Number.isFinite(value) && value > 0 ? value : fallback;
  }

  scheduleFit() {
    if (this._fitRaf != null) return;
    this._fitRaf = requestAnimationFrame(() => {
      this._fitRaf = null;
      this.fitAll();
    });
  }

  fitAll() {
    this.fitHeading();
    this.fitUniform(
      ".routine__step-title",
      this.isMobile() ? "--routine-title-max-m" : "--routine-title-max-d",
      this.isMobile() ? "--routine-title-fit-m" : "--routine-title-fit-d",
      (el) => el.scrollWidth <= el.clientWidth
    );
    this.fitUniform(
      ".routine__step-desc",
      this.isMobile() ? "--routine-desc-max-m" : "--routine-desc-max-d",
      this.isMobile() ? "--routine-desc-fit-m" : "--routine-desc-fit-d",
      (el) => el.scrollHeight <= el.clientHeight + 1
    );
  }

  fitHeading() {
    if (!this.heading) return;

    const maxVar = this.isMobile() ? "--routine-heading-max-m" : "--routine-heading-max-d";
    const fitVar = this.isMobile() ? "--routine-heading-fit-m" : "--routine-heading-fit-d";
    const maxSize = Math.round(this.readCssPx(maxVar, 22));
    const minSize = ROUTINE_TEXT_MIN;

    this.style.removeProperty(fitVar);
    void this.offsetHeight;

    for (let size = maxSize; size >= minSize; size -= 1) {
      this.style.setProperty(fitVar, size + "px");
      void this.offsetHeight;
      if (this.heading.scrollHeight <= this.heading.clientHeight + 1) return;
    }

    this.style.setProperty(fitVar, minSize + "px");
  }

  getStepElements(selector) {
    return this.steps
      .map((step) => step.querySelector(selector))
      .filter(Boolean);
  }

  fitUniform(selector, maxVarName, fitVarName, fits) {
    const elements = this.getStepElements(selector);
    if (!elements.length) return;

    const maxSize = Math.round(this.readCssPx(maxVarName, 12));
    const minSize = ROUTINE_TEXT_MIN;

    this.style.removeProperty(fitVarName);
    void this.offsetHeight;

    for (let size = maxSize; size >= minSize; size -= 1) {
      this.style.setProperty(fitVarName, size + "px");
      void this.offsetHeight;

      if (elements.every((el) => {
        if (el.clientWidth < 8) return true;
        return fits(el);
      })) {
        return;
      }
    }

    this.style.setProperty(fitVarName, minSize + "px");
  }
}

if (!customElements.get("routine-section")) {
  customElements.define("routine-section", RoutineSection);
}
